import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';
import { riassuntoCampagna } from '../pages/campagneData';

/* Eliminazione di una campagna: righe comprese.

   Il backend RIFIUTA (409) se qualche riga si e' risolta, e il suo messaggio spiega
   perche': i record nati in archivio rimandano a quelle righe, e consenso e codice
   opposizione vivono solo qui. Quel messaggio si mostra COM'E' e nel riquadro, non in un
   toast che scompare: e' la ragione per cui il gesto non si puo' fare, non un intoppo. */

// Si scrive questa parola per sbloccare il pulsante: il gesto e' irreversibile e il tasto
// sta accanto alla tendina delle campagne, dove un clic di troppo e' facile.
const PAROLA = 'conferma';

export default function CampagnaEliminaDialog({ campagna, onClose, onEliminata }) {
  const [busy, setBusy] = useState(false);
  const [rifiuto, setRifiuto] = useState('');
  const [parola, setParola] = useState('');

  if (!campagna) return null;

  const sbloccato = parola.trim().toLowerCase() === PAROLA;
  const chiudi = () => { if (!busy) { setRifiuto(''); setParola(''); onClose?.(); } };

  const elimina = async () => {
    if (!sbloccato) return;
    setBusy(true); setRifiuto('');
    try {
      await axios.delete(`${API}/campagne/${campagna.id}`);
      toast.success(`Lista «${campagna.nome}» eliminata`);
      onEliminata?.(campagna.id);
      onClose?.();
    } catch (e) {
      const stato = e.response?.status;
      const detail = e.response?.data?.detail;
      if (stato === 409 && detail) setRifiuto(detail);
      else toast.error(detail || 'Non sono riuscito a eliminare la lista');
    }
    setBusy(false);
  };

  const riassunto = riassuntoCampagna(campagna.contatori);

  return createPortal(
    <div className="confirm-overlay" onClick={chiudi}>
      <div className="camp-dlg" onClick={(e) => e.stopPropagation()}>
        <div className="camp-dlg-head">
          <span className="camp-dlg-titolo">Eliminare la lista?</span>
          <button type="button" className="camp-dlg-x" onClick={chiudi} aria-label="Chiudi">✕</button>
        </div>

        <div className="camp-dlg-body">
          <div>
            Sto per eliminare <b>«{campagna.nome}»</b>
            {riassunto ? <> ({riassunto})</> : null} e tutte le sue righe.
            Il file caricato non c’entra: resta dov’è.
          </div>
          {!rifiuto && (
            <div className="camp-box camp-box-warn">
              Sparisce anche il bottino delle indagini già fatte — siti, cellulari, altri
              fissi, email — e non si recupera.
            </div>
          )}
          {rifiuto && <div className="camp-box camp-box-err">{rifiuto}</div>}
          {!rifiuto && (
            <label className="camp-conferma">
              <span>Per procedere scrivi <b>{PAROLA}</b>:</span>
              <input type="text" value={parola} autoFocus autoComplete="off"
                     placeholder={PAROLA} disabled={busy}
                     onChange={(e) => setParola(e.target.value)}
                     onKeyDown={(e) => { if (e.key === 'Enter' && sbloccato) elimina(); }} />
            </label>
          )}
        </div>

        <div className="camp-dlg-piede">
          <button type="button" className="btn btn-secondary" onClick={chiudi} disabled={busy}>
            {rifiuto ? 'Chiudi' : 'Annulla'}
          </button>
          {!rifiuto && (
            <button type="button" className="btn btn-danger" onClick={elimina}
                    disabled={busy || !sbloccato}
                    title={sbloccato ? undefined : `Scrivi «${PAROLA}» per sbloccare`}>
              {busy ? 'Elimino…' : 'Sì, elimina'}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
